module.exports = __webpack_public_path__ + "static/img/Logo_Afsi.cd95d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support/Logo_Afsi.png
// module id = s/TJ
// module chunks = 36